import { Box, FormControl, FormHelperText, TextField, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'

import { useShowStyles } from '../common/show'

const ArchiveOrganisationExplanationText = ({ organisationName }) => {
  const translate = useTranslate()
  const getText = (index, options) => translate(`resources.organisations.actions.archive.helperText${index}`, options)

  return (
    <>
      <Typography sx={{ textAlign: 'justify' }}>{getText(1)}</Typography>
      <Typography sx={{ textAlign: 'justify', mt: 2 }}>{getText(2)}</Typography>
      <Box component="ul" sx={{ textAlign: 'justify', mt: 1, mb: 3, pl: 2.5 }}>
        {[3, 4].map((i) => (
          <Box key={i} component="li" sx={{ mb: 1 }}>
            {getText(i)}
          </Box>
        ))}
      </Box>
      <Typography sx={{ textAlign: 'justify' }}>{getText(5, { organisationName })}</Typography>
    </>
  )
}

const ArchiveOrganisationFormControl = ({ update, isPristine, error }) => {
  const showClasses = useShowStyles()
  const translate = useTranslate()
  return (
    <FormControl sx={{ display: 'block', mt: 2 }}>
      <TextField
        name="organisation_name"
        label={translate('resources.organisations.fields.name')}
        onChange={(event) => update({ organisation_name: event.target.value })}
        sx={showClasses.textFieldWithFullWidth}
        size="small"
        required
      />
      <FormHelperText error>{!isPristine && translate(error?.organisation_name)}</FormHelperText>
    </FormControl>
  )
}

export const archiveOrganisationConfirm = ({ record }) => ({
  validate: (state) => {
    if (!state.organisation_name || state.organisation_name !== record.name) {
      return { organisation_name: 'resources.organisations.actions.archive.validate' }
    }
    return null
  },
  content: (contentProps) => (
    <>
      <ArchiveOrganisationExplanationText organisationName={record.name} />
      <ArchiveOrganisationFormControl {...contentProps} />
    </>
  ),
  confirmLabel: 'resources.organisations.actions.archive.confirmLabel',
})
